"use client";
import { useEffect, useRef, useState } from "react";
import "./style.css";
import { Icon } from "@iconify/react";

export interface IDropdownButtonMenuItem {
  label: string;
  icon?: string;
  onClick?: (model?: any) => void;
  disabled?: boolean;
  className?: string;
  iconClassName?: string;
}

type Props = {
  label: string;
  icon?: string;
  className?: string;
  containerClassName?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  iconPosition?: "left" | "right";
  iconClassName?: string;
  iconWidth?: string;
  iconStyle?: React.CSSProperties;
  subtext?: string;
  subtextClassName?: string;
  loading?: boolean;
  menu: IDropdownButtonMenuItem[];
  model?: any;
};

const AppDropdownButton = ({
  label,
  icon,
  iconPosition,
  iconClassName,
  iconWidth,
  iconStyle,
  className,
  containerClassName,
  disabled,
  type = "button",
  subtext,
  subtextClassName,
  loading,
  menu,
  model,
}: Props) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const handleClick = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className={`app-dropdown-button-container ${containerClassName || ""}`}>
      {menuOpen && (
        <div className="app-dropdown-menu">
          {menu.map((item, index) => (
            <button
              key={index}
              disabled={item.disabled}
              type="button"
              className={`app-dropdown-menu-item ${item.className || ""}`}
              onClick={() => item.onClick && item.onClick(model)}
            >
              <div className="app-dropdown-menu-item-content">
                {item.label}
                {item.icon && <Icon icon={item.icon} />}
              </div>
            </button>
          ))}
        </div>
      )}
      <button
        disabled={loading || disabled}
        type={type}
        className={`app-dropdown-button ${loading ? "loading" : ""} ${className || ""}`}
        onClick={handleClick}
      >
        <div className="app-dropdown-button-content">
          {iconPosition === "left" && icon && <Icon icon={icon} width={iconWidth} className={iconClassName} />}
          {label}
          {loading && icon && <Icon icon={icon} width={iconWidth} className={iconClassName} />}
          {iconPosition !== "left" && icon && <Icon icon={icon} width={iconWidth} className={iconClassName} />}
        </div>
        {subtext && <p className={`app-dropdown-button-subtext ${subtextClassName}`}>{subtext}</p>}
      </button>
    </div>
  );
};

export default AppDropdownButton;
